<p>modal-footer works!</p>
